module.exports = __webpack_public_path__ + "static/media/H2_Small_TheChamps.42e18cf2.svg";